import { Button } from "newui/components/Button";

interface ComplianceQuestionsErrorProps {
	onRetry: () => void;
}

export const ComplianceQuestionsError = ({
	onRetry,
}: ComplianceQuestionsErrorProps) => {
	return (
		<div
			className="flex flex-col items-center gap-3 py-12 text-center"
			data-testid="compliance-questions-error"
		>
			<p className="text-sm text-red-600">
				We couldn&apos;t load the compliance questions.
			</p>
			<Button
				btntype="secondary"
				onClick={onRetry}
				data-testid="compliance-questions-retry-btn"
			>
				Try again
			</Button>
		</div>
	);
};
